module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ach1"
  }, [_vm._v("Also in")]), _vm._v(" "), _c('p', {
    staticClass: "ach2"
  }, [_vm._v("THE DEMONATA")]), _c('p', {
    staticClass: "ach3"
  }, [_c('strong', [_vm._v("series:")])]), _c('p', {
    staticClass: "acl"
  }, [_c('strong', [_vm._v("Lord Loss (Book 1)")])]), _c('p', {
    staticClass: "acl"
  }, [_c('strong', [_vm._v("Demon Thief (Book 2)")])]), _c('p', {
    staticClass: "acl"
  }, [_c('strong', [_vm._v("Slawter (Book 3)")])]), _c('p', {
    staticClass: "acl"
  }, [_c('strong', [_vm._v("Bec (Book 4)")])]), _c('p', {
    staticClass: "acl"
  }, [_c('strong', [_vm._v("Blood Beast (Book 5)")])]), _c('p', {
    staticClass: "acl"
  }, [_c('strong', [_vm._v("Demon Apocalypse (Book 6)")])]), _c('p', {
    staticClass: "acl11"
  }, [_c('strong', [_vm._v("For: ")])]), _c('p', {
    staticClass: "acl12"
  }, [_c('strong', [_vm._v("Bas — my full-time shadow")])]), _c('p', {
    staticClass: "acl1"
  }, [_c('strong', [_vm._v("OBE (Order of the Bloody Entrails) to: ")])]), _c('p', {
    staticClass: "acl12"
  }, [_c('strong', [_vm._v("court jester Sean Kenny — resting in fits of giggles!")])]), _c('p', {
    staticClass: "acl1"
  }, [_c('strong', [_vm._v("Reaped grimly by: ")])]), _c('p', {
    staticClass: "acl12"
  }, [_c('strong', [_vm._v("Stella Paskins")])]), _c('p', {
    staticClass: "acl1"
  }, [_c('strong', [_vm._v("Embalmed by: ")])]), _c('p', {
    staticClass: "acl12"
  }, [_c('strong', [_vm._v("Christopher Little & Co.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8493fe42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeathsShadow_adca-1.vue
// module id = 63
// module chunks = 0